import { Grid } from "@material-ui/core";
import { TransferenciaGetModel } from "model/api/gestao/transferencia/transferencia-get-model";
import { TransferenciaFormRef } from "../../dialog-transferencia";
import { FormTransferencia } from "views/components/form/master/transferencia/form-transferencia";
import { AccordionHistoricoTransferencia } from "./components/accordion-historico-transferencia";

interface VisualizacaoTransferenciaProps {
    formRef: React.RefObject<TransferenciaFormRef>;
    carregando: boolean;
    transferencia: TransferenciaGetModel;
}

export const VisualizacaoTransferencia = ({
    formRef,
    carregando,
    transferencia,
}: VisualizacaoTransferenciaProps) => {

    const loading = carregando

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <FormTransferencia
                    loading={loading}
                    showLoading
                    onSubmit={() => { }}
                    ref={formRef}
                    transferencia={transferencia}
                />
            </Grid>
            <Grid item xs={12}>
                <AccordionHistoricoTransferencia
                    historico={transferencia.historicos}
                />
            </Grid>
        </Grid>
    )
}